<template>
  <div>
    <section>
      <p ref="summaryParagraph" class="summary mb-0">
        {{ summary }}
      </p>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    summary: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.summary {
  white-space: pre-line;
}
</style>
